'use client';

import React from 'react';

import { CldImage } from 'next-cloudinary';
import NextImage from 'next/image';

import { useImage } from './hooks/useImage';

import type { ImageProps } from './_props';

export function ImageComponent({
  src,
  sizes,
  dpr = 'auto',
  quality = undefined,
  flags = 'lossy',
  ...props
}: ImageProps) {
  const { parsedSrc, loader, parsedSizes, type, cloudinaryUrl, unoptimized } = useImage({ src, sizes });

  if (type !== 'New Cloudinary') {
    return <NextImage src={parsedSrc} loader={loader} sizes={parsedSizes} {...props} />;
  }

  return (
    <CldImage
      src={parsedSrc}
      sizes={parsedSizes}
      dpr={dpr}
      flags={flags}
      unoptimized={unoptimized}
      quality={quality}
      config={{
        url: {
          secureDistribution: cloudinaryUrl,
          privateCdn: true,
        },
        cloud: {
          cloudName: '.',
        },
      }}
      {...props}
    />
  );
}

export default ImageComponent;
